import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { resolverHome } from '@/utils/homeRoute';

/**
 * Redirect inicial ("/") sensível à role do usuário. Evita o salto indireto
 * via /dashboard, que seria barrado pelo DashboardGuard para professores/alunos.
 */
export const HomeRedirect: React.FC = () => {
  const { roles, rolesLoading, user, loading } = useAuth();
  if (loading || rolesLoading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={resolverHome(roles)} replace />;
};
